const childTitleAge = document.querySelectorAll(".child_link-title--age");
const grandchildLinkWrapperAge = document.querySelectorAll(
  ".grandchild_link-wrapper--age"
);
const childTitleAgeMobile = document.querySelectorAll(".child_link-title-mobile--age");
const grandchildLinkWrapperAgeMobile = document.querySelectorAll(
  ".grandchild_link-wrapper-mobile--age"
);

function initializeFirstChild() {
  const firstChild = childTitleAge[0];
  const firstChildIndex = firstChild.getAttribute("data-index");

  firstChild.classList.add("is-active");

  grandchildLinkWrapperAge.forEach((grandChild) => {
    if (grandChild.getAttribute("data-index") === firstChildIndex) {
      grandChild.style.display = "flex";
    } else {
      grandChild.style.display = "none";
    }
  });

  const firstChildMobile = childTitleAgeMobile[0];
  const firstChildMobileIndex = firstChildMobile.getAttribute("data-index");

  firstChildMobile.classList.add("is-active");

  grandchildLinkWrapperAgeMobile.forEach((grandChild) => {
    if (grandChild.getAttribute("data-index") === firstChildMobileIndex) {
      grandChild.style.display = "flex";
    } else {
      grandChild.style.display = "none";
    }
  });
}

initializeFirstChild();

childTitleAge.forEach((child) => {
  const childIndex = child.getAttribute("data-index");
  child.addEventListener("click", function () {
    childTitleAge.forEach(child => child.classList.remove('is-active'));
    child.classList.add("is-active");

    grandchildLinkWrapperAge.forEach((grandChild) => {
      const grandChildIndex = grandChild.getAttribute("data-index");

      if (childIndex === grandChildIndex) {
        grandChild.style.display = "flex";
      } else {
        grandChild.style.display = "none";
      }
    });
  });
});

childTitleAgeMobile.forEach((child) => {
  const childIndex = child.getAttribute("data-index");
  child.addEventListener("click", function () {
    childTitleAgeMobile.forEach(child => child.classList.remove('is-active'));
    child.classList.add("is-active");

    grandchildLinkWrapperAgeMobile.forEach((grandChild) => {
      const grandChildIndex = grandChild.getAttribute("data-index");

      if (childIndex === grandChildIndex) {
        grandChild.style.display = "flex";
      } else {
        grandChild.style.display = "none";
      }
    });
  });
});
